import React, { useState, useEffect } from 'react';
import { useParams, Link } from "react-router-dom";
import { getPlayers } from '../../data/';
import { CircularProgress, Dialog, DialogTitle, DialogContent, makeStyles, Typography, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FilterListIcon from '@material-ui/icons/FilterList';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Checkbox from '@material-ui/core/Checkbox';

export default function Players(props) {
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAvailability, setShowAvailability] = useState(false);
    const [scoreHeaders, setScoreHeaders] = useState([]);
    const [filters, setFilters] = useState({
        'availability': [],
        'role': [],
        'team': [],
    });
    const [popovers, setPopovers] = useState({});

    let {tournament, leagueID} = useParams();
    useEffect(() => {
        async function fetchPlayers() {
            const data = await getPlayers(tournament, leagueID);
            const players = data['players'];
            players.sort((e1, e2) => e2.totalScore - e1.totalScore);
            setPlayers(players || []);
            setShowAvailability(data.waivers);
            setLoading(false);
            const scoreHeaders = Object.keys((players || [])[0]).filter(h => h.startsWith('gw'));
            if (scoreHeaders.length > 0) {
                scoreHeaders.sort((e1, e2) => {
                    return parseInt(e2.replace('gw', '')) - parseInt(e1.replace('gw', ''));
                });
                setScoreHeaders(scoreHeaders);
            }
        }
        fetchPlayers()
    }, [tournament, leagueID]);

    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: theme.spacing(5),
            maxWidth: 700,
            marginLeft: 'auto',
            marginRight: 'auto',
            'flexWrap': 'wrap',
        },
        table: {
            display: 'flex-item',
            flexBasis: '100%',
            marginTop: theme.spacing(3),
        },
        filter: {
            cursor: 'pointer',
        },
        popover: {
        }
    }));
    const classes = useStyles();

    const showPlayer = (player) => {
        if (filters.availability.length !== 0) {
            if (!filters.availability.includes(player.available)) {
                return false;
            }
        }
        if (filters.role.length !== 0) {
            if (!filters.role.includes(player.pos)) {
                return false;
            }
        }
        if (filters.team.length !== 0) {
            if (!filters.team.includes(player.team)) {
                return false;
            }
        }
        return true;
    };

    const makePopover = (elementId, filterName, filterOptions) => {
        const handleClose = () => {
            const newPopovers = {};
            newPopovers[elementId] = undefined;
            setPopovers({
                ...popovers,
                ...newPopovers,
            });
        };
        const changeFilter = (event, f) => {
            const newFilters = {
                ...filters,
            }
            if (event.target.checked) {
                newFilters[filterName].push(f);
            } else {
                newFilters[filterName] = newFilters[filterName].filter((p) => p !== f);
            }
            setFilters({
                ...newFilters,
            })
        };
        return (
        <Dialog
            id={`${elementId}-popover`}
            open={popovers[elementId] !== undefined}
            anchorEl={document.getElementById(elementId)}
            onClose={handleClose}
            className={classes.popover}>
            <DialogTitle id={`${elementId}-title`}>
                {filterName.toLocaleUpperCase()}
            </DialogTitle>
            <DialogContent id={`${elementId}-content`}>
                <List>
                    {filterOptions.map((f, i) => 
                    <ListItem>
                        <Checkbox checked={filters[filterName].includes(f)}
                            onChange={(e) => changeFilter(e, f)} />
                        {typeof f === "boolean" ? "" + f : f}
                    </ListItem>
                    )}
                </List>
            </DialogContent>
        </Dialog>)
    }

    const popoverClickHandler = (elementId) => {
        return () => {
            const newPopovers = {};
            newPopovers[elementId] = document.getElementById(elementId);
            setPopovers({
                ...popovers,
                ...newPopovers,
            });
        }
    };

    const teams = loading ? [] : [...new Set(players.map(p => p.team))];
    teams.sort();

    return (
        <div className={classes.root}>
            <div style={{flexBasis: '100%'}}>
            <Typography variant="h5" style={{'flexGrow': 1}}>
                <Link to={`/leagues/${leagueID}`} style={{marginTop: '5px', 'flexGrow': 0}} >
                    <Button variant='contained'>
                        <ArrowBackIcon /> League
                    </Button>
                </Link>
            </Typography>
            </div>
            <TableContainer component={Paper} className={classes.table}>
                {loading && <CircularProgress />}
                <Table aria-label="simple table">
                    <TableBody>
                        <TableRow key={`header`}>
                            <TableCell>Player</TableCell>
                            <TableCell>
                                <span>Role</span>
                                <FilterListIcon id='role-filter' className={classes.filter}
                                    onClick={popoverClickHandler('role-filter')}
                                />
                            </TableCell>
                            {showAvailability &&
                            <TableCell>
                                <span>Avlbl</span>
                                <FilterListIcon id='avl-filter' className={classes.filter}
                                    onClick={popoverClickHandler('avl-filter')}
                                />
                            </TableCell>}
                            <TableCell>Squads</TableCell>
                            <TableCell>
                                <span>Team</span>
                                <FilterListIcon id='team-filter' className={classes.filter}
                                    onClick={popoverClickHandler('team-filter')}
                                />
                            </TableCell>
                            <TableCell align="right" className={classes.score}>Total</TableCell>
                            {scoreHeaders.map(h => {
                                return <TableCell align="right" key={h} className={classes.score}>{h}</TableCell>
                            })}
                        </TableRow>
                        {(players || []).filter((p, i) => showPlayer(p)).map((p, i) => {
                            return <RenderPlayer player={p} i={i} key={i} scoreHeaders={scoreHeaders}
                                showAvailability={showAvailability} />
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {!loading && makePopover('role-filter', 'role', ['BAT', 'BOW', 'AR', 'WK'])}
            {!loading && makePopover('avl-filter', 'availability', [true, false])}
            {!loading && makePopover('team-filter', 'team', teams)}
        </div>
    )
}

function RenderPlayer(props) {
    const useStyles = makeStyles((theme) => ({
        dialogMenu: {
            padding: theme.spacing(1)
        },
        score: {
            cursor: 'pointer',
            color: 'blue',
            textDecoration: 'underline',
        }
    }));

    const player = props.player;
    const i = props.i;

    const [expOpen, setExpOpen] = useState({open: false});
    function handleOpen(match) {
        setExpOpen({open: true, match: match})
    }
    function handleClose() {
        setExpOpen({open: false});
    }

    const classes = useStyles();

    return (
        <TableRow key={`p-${i}`}>
            <TableCell>{player.name}</TableCell>
            <TableCell>{player.pos}</TableCell>
            {props.showAvailability && <TableCell>{player.available ? <CheckIcon /> : <ClearIcon />}</TableCell>}
            <TableCell>{(player.squads || []).map((t, i) => <span key={i}>{t}<br /></span>)}</TableCell>
            <TableCell>{player.team}</TableCell>
            <TableCell align="right">{player.totalScore}</TableCell>
            {props.scoreHeaders.map((gw) => {
                const scores = player[gw]['scores'].map((score, idx) => {
                    const key = player[gw]['matches'][idx];
                    return (
                    <div key={key} className={classes.score} onClick={(e) => handleOpen(key)}>
                        {score}
                    </div>)});
                return <TableCell align="right" key={`${player.id}-${gw}`}>{scores}</TableCell>;
            })}
            {props.scoreHeaders.map((gw, i) => {
                return player[gw]['explanations'].map((explanations, idx) => {
                    const matchId = player[gw]['matches'][idx];
                    const explanationsDiv = (explanations || []).map((e, i) => (<div key={i}>{e}</div>));
                    return (
                    <Dialog key={`${player.id}-${matchId}-exp`} aria-labelledby="simple-dialog-title" open={expOpen.open && expOpen.match === matchId}
                        onClose={handleClose} className={classes.dialogMenu}>
                        <DialogTitle id="simple-dialog-title-">Scoring breakdown - {player.name} - match {matchId}</DialogTitle>
                        <DialogContent dividers>
                            {explanationsDiv}
                        </DialogContent>
                    </Dialog>);
                });
            })}
        </TableRow>
    )
}